import { Image, Platform, Text, TouchableOpacity, View } from 'react-native';
import { styles } from '../theme';
import type { Translation } from '../types';
import { FeaturedEventVideo } from './FeaturedEventVideo';

const webCardStack = Platform.OS === 'web'
  ? { isolation: 'isolate', transformStyle: 'preserve-3d' } as object
  : null;
const webOverlay = Platform.OS === 'web'
  ? { transform: 'translate3d(0,0,0)' } as object
  : null;

export function FeaturedEventCard({
  t,
  title,
  subtitle,
  cta,
  videoUrl,
  imageUrl,
  label,
  onPress,
}: {
  t: Translation;
  title: string;
  subtitle: string;
  cta: string;
  videoUrl?: string | null;
  imageUrl?: string | null;
  label?: string;
  onPress: () => void;
}) {
  return (
    <TouchableOpacity
      style={[
        styles.featureCard,
        webCardStack,
      ]}
      onPress={onPress}
      activeOpacity={0.92}
    >
      {videoUrl || imageUrl ? (
        <View style={styles.featureCardMedia} pointerEvents="none">
          {videoUrl ? (
            <FeaturedEventVideo uri={videoUrl} />
          ) : (
            <Image source={{ uri: imageUrl! }} style={styles.featureCardMediaFill} resizeMode="cover" />
          )}
        </View>
      ) : null}
      <View style={[styles.featureCardScrim, webOverlay]} pointerEvents="none" />
      <View style={[styles.featureCardContent, webOverlay]}>
        <Text style={styles.featureLabel}>{label ?? t.featuredEvent}</Text>
        <Text style={styles.featureTitle}>{title}</Text>
        <Text style={styles.featureCopy}>{subtitle}</Text>
        <Text style={styles.featureButton}>{cta}</Text>
      </View>
    </TouchableOpacity>
  );
}
